import React from "react";
import { checkTextTranslation, getObject, replaceVariablesLabelWithKeys } from "../../utils/useful";
import { evaluate } from 'mathjs'
import formulaEvaluator from "../../utils/formulaParser";
import { stripHtml } from "string-strip-html";

// const evaluator = new FormulaEvaluator(data);

// used for making the prop types of this component
// import PropTypes from "prop-types";

// Example usage:

// const data = {
//     name: "ChatGPT",
//     number: 3.14,
//     val1: 10,
//     val2: 20,
//     arr: [1, 2, 3],
// };



class FormulaInput extends React.Component {
    state = {
        value: '',
        showValue: ''
    }

    componentDidMount() {
        this.init()

        // const data = {
        //     name: "ChatGPT",
        //     number: 3.14,
        //     val1: 10,
        //     val2: 20,
        //     arr: [1, 2, 3],
        // };

        // console.log(formulaEvaluator.evaluate(`LEN({{name}})`, data)); // 7
        // console.log(formulaEvaluator.evaluate(`UPPER(name)`, data)); // CHATGPT
        // console.log(formulaEvaluator.evaluate(`IF(val1 > val2, "Yes", "No")`, data)); // No
        // console.log(formulaEvaluator.evaluate(`SWITCH(val1, 5, "Five", 11, "Ten", "Other")`, data)); // Ten
        // console.log(formulaEvaluator.evaluate(`ABS(-5.5)`, data)); // 5.5
        // console.log(formulaEvaluator.evaluate(`SIN(0)`, data)); // 0
        // console.log(formulaEvaluator.evaluate(`ASIN(0.5)`, data)); // ~0.5235
        // console.log(formulaEvaluator.evaluate(`val1 + val2 * 2`, data)); // (naive eval left to right: 10 + 20 = 30 * 2 = error but here it evaluates 10 + 20 first, so 30 * 2 = 60; note no operator precedence)
        // console.log(formulaEvaluator.evaluate(`NOT(TRUE)`, data)); // false
        // console.log(formulaEvaluator.evaluate(`AND(TRUE, FALSE)`, data)); // false
        // console.log(formulaEvaluator.evaluate(`OR(FALSE, TRUE)`, data)); // true
        // console.log(formulaEvaluator.evaluate(`ABS(-5.5) + IF(val1 > val2, "Hi", "Bye")`));
        // console.log(formulaEvaluator.evaluate(`ABS(-5.5) + LEN({{name}})`, data));

    }

    componentDidUpdate(prevProps) {
        if (this.props.fullData != prevProps.fullData || this.props.data != prevProps.data) {
            // console.log(this.changeToPriceValue(this.props.data))
            this.init()
        }
    }


    init() {
        if (this.props.data != null) {

            this.setState({ showValue: this.props.data })

        } else {

            let showValue = ''
            let formula = this.props.header.information?.formula
            let params = this.props.params

            let replacedFormula = replaceVariablesLabelWithKeys(stripHtml(formula).result, params, ' - ', 'data')?.content

            // console.log("params", params)
            // console.log("replacedFormula", replacedFormula)

            showValue = formulaEvaluator.evaluate(replacedFormula, this.props.fullData)
            // console.log("showValue", showValue)

            if (showValue) {
                showValue = Number.isInteger(showValue) ? showValue : showValue.toFixed(2)
            }


            // if (formula) {
            //     try {

            //         let reg = new RegExp('\{\{(.*?)\}\}', 'g')

            //         let matches = formula.match(reg)
            //         let fullData = this.props.fullData
            //         if (matches) {
            //             for (let index = 0; index < matches.length; index++) {
            //                 const match = matches[index];


            //                 let key = match.replace(/{/g, '').replace(/}/g, '')

            //                 // console.log(fullData)
            //                 // console.log(key)

            //                 let value = getObject(fullData, key) ?? 0

            //                 let nreg = new RegExp(match, 'g')
            //                 formula = formula.replace(nreg, value)


            //             }
            //         }

            //         // console.log(formula)
            //         showValue = evaluate(formula)
            //         showValue = Math.round(showValue * 1000) / 1000

            //         // console.log(showValue)
            //         if (showValue == -Infinity && this.props.header.information?.minusInfinity) {
            //             showValue = this.props.header.information?.minusInfinity
            //         }

            //     } catch {
            //         showValue = "ERROR"
            //     }
            //     // console.log(showValue)
            //     // this.changeToPriceValue(showValue)
            // }

            this.setState({ showValue })
        }
    }



    // handleChange(evt) {
    //     if (evt.target.validity.valid) {
    //         if (!evt.target.value.includes('-') || evt.target.value.lastIndexOf('-') == 0) {
    //             let value = ''
    //             let minus = false
    //             if (evt.target.value != "") {
    //                 value = evt.target.value.replace(new RegExp(',', 'g'), '')
    //                 if (value != '-') {
    //                     // value = Number(value)
    //                     minus = (Number(value) < 0) ? true : false

    //                 } else {
    //                     minus = true

    //                 }
    //             } else {
    //                 value = ''
    //                 minus = false
    //             }

    //             this.setState({ minus: minus })
    //             // console.log(value)
    //             let newValue = parseFloat(value)
    //             if (isNaN(newValue)) {
    //                 newValue = null
    //             }

    //             // if (newValue != null) {
    //             // this.setState({ value, showValue: this.changeToPriceValue(String(value)) });
    //             this.props.changeValue(this.props.header.key, newValue, this.props.extra)
    //             // }
    //             if (value === '-' && this.props.header.information?.negativeAllowed) {
    //                 newValue = '-'
    //             }
    //             // console.log(this.changeToPriceValue(newValue) )
    //             this.setState({ value, showValue: this.changeToPriceValue(newValue) });

    //         }
    //     }
    // }

    // conditionalSettings(param, condition) {
    //     if (this.props.header.information.settings) {
    //         if (this.props.header.information.settings[param] == condition) {
    //             return true
    //         }
    //     }
    //     return false
    // }



    // changeToPriceValue(Svalue) {
    //     let value = String(Svalue)
    //     // console.log(value)
    //     let final = ''
    //     let minus = false

    //     if (Svalue != null) {
    //         if (parseFloat(value) < 0) {
    //             // console.log(value)
    //             minus = true
    //             value = value.replace('-', '')
    //         }

    //         let fullValue = String(value).split('.')
    //         // console.log(fullValue[0])
    //         let newValue = fullValue[0]

    //         newValue = String(newValue).split('')
    //         let count = 0
    //         for (let i = newValue.length - 1; i >= 0; i--) {
    //             final = newValue[i] + final
    //             count++
    //             if (count == 3 && i != 0) {
    //                 final = ',' + final
    //                 count = 0
    //             }
    //         }

    //         final = final + (value.includes('.') ? ('.' + (fullValue[1] ? fullValue[1] : '')) : '')
    //     } else {
    //         return ''
    //     }
    //     // console.log(minus ? ('-' + final) : final)
    //     return minus ? ('-' + final) : final
    // }


    render() {
        let info = this.props.header.information
        let pattern = "^[.,0-9]+$"
        if (info.negativeAllowed) {
            pattern = "^[-.,0-9]+$"
        }
        return (
            <div className='mt-0 w-100 flexc' >


                {info.formula ? (
                    <p className="">{this.state.showValue}</p>

                ) : (
                    <p className="pld-2 prd-1 opacity-7"></p>

                )}

                {/* {info.leftIndicator && (
                    <p className="prd-2 pld-1 opacity-7">{info.leftIndicator}</p>
                )} */}

                {/* <input pattern={pattern} step="0.01" disabled={true} onInput={this.handleChange.bind(this)} onChange={() => { }} value={this.state.showValue ? this.state.showValue : ''} placeholder={checkTextTranslation(info.placeholder)} className="transpanet-input" /> */}

                {/* {info.rightIndicator && (
                    <p className="pld-2 prd-1 opacity-7">{info.rightIndicator}</p>
                )} */}

            </div>
        )
    }
}

export default FormulaInput;
